import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state,$uibModal, UserLabelsService, Alert) {
        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
		this.$uibModal=$uibModal;
		
    }

    $onInit() {
       //console.log(this);
	   

    }

  	rename(newName){
		const companyId = this.companyId;
		const labelId = this.labelGroup.id;
		this.UserLabelsService.renameLabel({companyId,labelId},newName).$promise
		.then(()=>{this.$state.reload('company.user-directories.saaspass-users')})
		.then(() => this.Alert('success', 'company.saaspass-users.label.settings.renamed'))
		.catch((error) => {});
		//.finally(()=>{});
		
	}
	
	showDeleteModal(){
		 this.$uibModal
            .open({
                component: 'companyUserLabelDelete',
                resolve: {
                    companyId: () => this.companyId,
                    labelId: () => this.labelGroup.id,
                },
            }).result
            .then(() => this.$state.go('company.user-directories.saaspass-users', {companyId: this.companyId}, { reload: true, inherit: false, notify: false }))
            .then(() => {
                const key = 'company.user-directories.saaspass-users.user-labels.label.settings.delete.success';
                const variables = {groupName: this.labelGroup.labelName};
                this.Alert('success', key, variables);
            })
	}
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/label-settings/label-settings.controller.js